import React from "react"
import {Columns, Form, Table} from "react-bulma-components";
import {readableDate} from "../../utils";
import PrintCustomerCollectionSheet from "./PrintCustomerCollectionSheet";


class PrintSalesInvoice extends React.Component{

    round(number){
        if(number) {
            return (Math.round(number * 100)) / 100;
        }
        else{
            return 0
        }
    }


    render() {
        let vehicle = this.props.vehicle;
        let financeAgreement = this.props.finance;
        let type = this.props.type;

        const getTitle = (type) => {
            if(type === "pro"){
                return "PRO FORMA"
            }
            else if(type === "invoice"){
                return "INVOICE"
            }
            else if (type === "quote"){
                return "QUOTE"
            }
            return ""
        }

        const sold_price = financeAgreement.sold_price ? parseFloat(financeAgreement.sold_price) : 0.00;
        const sale_warranty_cost = financeAgreement.sale_warranty_cost ? parseFloat(financeAgreement.sale_warranty_cost) : 0.00;
        const vat = financeAgreement.no_vat ? 0 : financeAgreement.sold_price ? parseFloat(sold_price * 0.2) : 0;
        const sale_deposit = financeAgreement.sale_deposit ? parseFloat(financeAgreement.sale_deposit) : 0;
        const totalPrice = sold_price + sale_warranty_cost + vat;

        const getCompanyInfo = () => {
            if(financeAgreement.department) {
                if (financeAgreement.department.name === "RAPID FIT") {
                    return (
                        <Columns.Column>
                            <p className={"table-header-bold small-text"}>Vehicle Sales/Daily & Long Term Van Hire
                                Available</p>
                            <p className={"table-header-bold small-text"}>Van Sales Direct Ltd. Registered Address :
                                Unit 7, Cherry Tree Road, Tibenham, Norwich, Norfolk NR16 1PH</p>
                            <p className={"table-header-bold small-text"}>Company Registration 16322863 - VAT
                                Registration Number - 490-9953-39</p>
                        </Columns.Column>
                    )
                } else if (financeAgreement.department.name === "VAN SALES DIRECT") {
                    return (
                        <Columns.Column>
                            <p className={"table-header-bold small-text"}>Vehicle Sales/Daily & Long Term Van Hire
                                Available</p>
                            <p className={"table-header-bold small-text"}>Van Sales Direct Ltd. Registered Address :
                                Unit 1, Cherry Tree Road, Tibenham, Norwich, Norfolk NR16 1PH</p>
                            <p className={"table-header-bold small-text"}>Company Registration 15468328 - VAT
                                Registration Number - 460-4336-12</p>
                        </Columns.Column>
                    )
                } else if (financeAgreement.department.name === "DIRECT VAN HIRE") {
                    return (
                        <Columns.Column>
                            <p className={"table-header-bold small-text"}>Vehicle Sales/Daily & Long Term Van Hire
                                Available</p>
                            <p className={"table-header-bold small-text"}>Direct Van Hire LTD. Registered Address : Unit
                                6, Cherry Tree Road, Tibenham, Norwich, Norfolk NR16 1PH</p>
                            <p className={"table-header-bold small-text"}>Company Registration 16259117 - VAT
                                Registration Number - 488-4824-34</p>
                        </Columns.Column>
                    )
                } else if (financeAgreement.department.name === "RENTALS DIRECT") {
                    return (
                        <Columns.Column>
                            <p className={"table-header-bold small-text"}>Vehicle Sales/Daily & Long Term Van Hire
                                Available</p>
                            <p className={"table-header-bold small-text"}>Rentals Direct Ltd. Registered Address : Unit
                                3, Cherry Tree Road, Tibenham, Norwich, Norfolk NR16 1PH</p>
                            <p className={"table-header-bold small-text"}>Company Registration 06980659 - VAT
                                Registration Number - 981-3902-05</p>
                        </Columns.Column>
                    )
                }
            }
            else{
                return (
                    <Columns.Column>

                    </Columns.Column>
                )
            }
        }

        const getBankInfo = () => {
            if(financeAgreement.department) {
                if (financeAgreement.department.name === "RENTALS DIRECT") {
                    return (
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                            <tr>
                                <th className={"table-header-bold fill-grey border-black small-text"}>PAYMENT DETAILS
                                    :
                                </th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>LLOYDS BANK PLC</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>RENTALS DIRECT LTD</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>SORT CODE : 30 64 22</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>ACCOUNT NUMBER : 32521360
                                </th>
                            </tr>
                            </tbody>
                        </Table>
                    )
                } else if (financeAgreement.department.name === "RAPID FIT") {
                    return (
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                            <tr>
                                <th className={"table-header-bold fill-grey border-black small-text"}>PAYMENT DETAILS
                                    :
                                </th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>TIDE</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>RAPID FIT LTD</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>SORT CODE : 04 06 05</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>ACCOUNT NUMBER : 27659310
                                </th>
                            </tr>
                            </tbody>
                        </Table>
                    )
                } else if (financeAgreement.department.name === "DIRECT VAN HIRE") {
                    return (
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                            <tr>
                                <th className={"table-header-bold fill-grey border-black small-text"}>PAYMENT DETAILS
                                    :
                                </th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>BARCLAYS</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>DIRECT VAN HIRE LTD</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>SORT CODE : 20 17 30</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>ACCOUNT NUMBER : 53733823
                                </th>
                            </tr>
                            </tbody>
                        </Table>
                    )
                } else if (financeAgreement.department.name === "VAN SALES DIRECT") {
                    return (
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                            <tr>
                                <th className={"table-header-bold fill-grey border-black small-text"}>PAYMENT DETAILS
                                    :
                                </th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>LLOYDS BANK PLC</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>VAN SALES DIRECT LTD</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>SORT CODE : 30-54-66</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>ACCOUNT NUMBER : 29975660
                                </th>
                            </tr>
                            </tbody>
                        </Table>
                    )
                }
            }
            else{
                return (
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                            <tr>
                                <th className={"table-header-bold fill-grey border-black small-text"}>PAYMENT DETAILS :</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}></th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}></th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>SORT CODE :</th>
                            </tr>
                            <tr>
                                <th className={"table-header-bold border-black small-text"}>ACCOUNT NUMBER :</th>
                            </tr>
                            </tbody>
                        </Table>
                    )
            }
        }

        const getPhoneNumer = () => {
            if(financeAgreement.department) {
                if (financeAgreement.department.name === "RENTALS DIRECT") {
                    return "Tel: 01953 665421 Email: sales@rentalsdirect4u.co.uk"
                } else if (financeAgreement.department.name === "VAN SALES DIRECT") {
                    return "Tel: 01953 528600 Email: sales@vansalesdirect.uk"
                } else if (financeAgreement.department.name === "DIRECT VAN HIRE") {
                    return "Tel: 01953 528601 Email: hire@direct-vanhire.co.uk"
                } else if (financeAgreement.department.name === "RAPID FIT") {
                    return "Tel: 01953 528800 Email: info@rapidfit.co.uk"
                } else {
                    return ""
                }
            }
        }



        let service = this.props.serviceData;
        return (
            <div className={"print-background"}>
                <Columns>
                    <Columns.Column>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th className={"table-header-bold out-border-top-black out-border-middle-black"}>{financeAgreement.department ? financeAgreement.department.name + " LTD" : ""}</th>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold out-border-middle-black out-border-bottom-black"}>Tibenham, Norfolk NR16 1PH</th>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold border-black small-text"}>{getPhoneNumer()}</th>
                                </tr>
                            </tbody>
                        </Table>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th colSpan={4} className={"table-header-bold fill-grey border-black"}>{getTitle(type)}</th>
                                </tr>
                                <tr>
                                    <th colSpan={2} className={"table-header-bold fill-grey border-black small-text"}>INVOICE ADDRESS :</th>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>NUMBER :</th>
                                    <td className={"wide-column border-black"} data-testId={"pro-forma-number"}>{vehicle.fleet_number}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"wide-column out-border-top-black out-border-middle-black"} data-testId={"sale-invoice-address"}>{financeAgreement.sale_invoice_address}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>DATE :</th>
                                    <td className={"wide-column border-black"} data-testId={"sale-invoice-date"}>{readableDate(financeAgreement.internal_sale_date)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"wide-column out-border-middle-black"}></td>
                                    <th colSpan={2} className={"table-header-bold fill-grey border-black small-text"}>NAME</th>
                                </tr>
                                <tr>
                                    <td colSpan={2} className={"wide-column out-border-middle-black out-border-bottom-black"}></td>
                                    <td colSpan={2} className={"wide-column out-border-top-black out-border-middle-black"} data-testId={"sale-customer"}>{financeAgreement.sale_customer ? financeAgreement.sale_customer.display_name : ""}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>POST CODE :</th>
                                    <td className={"wide-column border-black"} data-testId={"postcode"}>{financeAgreement.sale_customer ? financeAgreement.sale_customer.postcode : ""}</td>
                                    <td colSpan={2} className={"wide-column out-border-middle-black out-border-bottom-black"}></td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th colSpan={4} className={"table-header-bold fill-grey border-black small-text"}>DESCRIPTION</th>
                                </tr>
                                <tr>
                                    <td colSpan={4} className={"wide-column border-black"}>
                                        USED VEHICLE - SOLD AS SEEN - {vehicle.make ? vehicle.make.name : ""} - {vehicle.model ? vehicle.model.name : ""} - {vehicle.variant}
                                    </td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>REGISTRATION :</th>
                                    <td className={"wide-column border-black"} data-testId={"vehicle-reg"}>{vehicle.registration}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>DATE OF FIRST REG. :</th>
                                    <td className={"wide-column border-black"} data-testId={"vehicle-dofr"}>{readableDate(vehicle.first_registration_date)}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>CHASSIS NUMBER :</th>
                                    <td className={"wide-column border-black"} data-testId={"vehicle-vin"}>{vehicle.vin_number}</td>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>MILEAGE :</th>
                                    <td className={"wide-column border-black"} data-testId={"vehicle-mileage"}>{vehicle.mileage}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>SALES PRICE :</th>
                                    <td className={"wide-column border-black"} data-testId={"sold-price"}>£{this.round(sold_price)}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>EXTRA WARRANTY COST :</th>
                                    <td className={"wide-column border-black"} data-testId={"warranty-cost"}>£{this.round(sale_warranty_cost)}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>SUB TOTAL :</th>
                                    <td className={"wide-column border-black"} data-testId={"sub-total"}>£{this.round(sold_price + sale_warranty_cost)}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>{financeAgreement.no_vat ? "VAT 0%": "VAT 20% :"}</th>
                                    <td className={"wide-column border-black"} data-testId={"vat"}>£{this.round(vat)}</td>
                                </tr>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>TOTAL :</th>
                                    <td className={"wide-column border-black"} data-testId={"total"}>£{this.round(totalPrice)}</td>
                                </tr>
                            <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>PART EXCHANGE :</th>
                                    <td className={"wide-column border-black"} data-testId={"part-exchange"}>£{this.round(financeAgreement.part_exchange)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th colSpan={4} className={"table-header-bold fill-grey border-black small-text"}>BALANCE :</th>
                                    <td colSpan={4} className={"wide-column border-black"} data-testId={"balance"}>£{this.round(totalPrice) - this.round(financeAgreement.part_exchange)}</td>
                                </tr>
                                <tr>
                                    <th colSpan={4} className={"table-header-bold fill-grey border-black small-text"}>LESS DEPOSIT PAID :</th>
                                    <td colSpan={4} className={"wide-column border-black"} data-testId={"deposit"}>£{financeAgreement.sale_deposit}</td>
                                </tr>
                                <tr>
                                    <th colSpan={4} className={"table-header-bold fill-grey border-black small-text"}>OUT STANDING BALANCE :</th>
                                    <td colSpan={4} className={"wide-column border-black"} data-testId={"outstanding-balance"}>£{this.round(totalPrice-sale_deposit) - this.round(financeAgreement.part_exchange)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>Notes</th>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Textarea
                                            value={financeAgreement.free_print_text}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table bordered size={"fullwidth"}>
                            <tbody>
                                <tr>
                                    <th className={"table-header-bold fill-grey border-black small-text"}>VEHICLE TO BE
                                        DELIVERED TO :
                                    </th>
                                </tr>
                                <tr>
                                    <td className={"wide-column border-black"} data-testId={"delivery-address"}>{financeAgreement.sale_delivery_address}</td>
                                </tr>
                                <tr>
                                    <td className={"wide-column border-black"}>{financeAgreement.sale_customer ? financeAgreement.sale_customer.display_name : ""}</td>
                                </tr>
                                <tr>
                                    <td className={"wide-column border-black"}></td>
                                </tr>
                            </tbody>
                        </Table>
                        {getBankInfo()}
                    </Columns.Column>
                </Columns>
                <Columns>
                    {getCompanyInfo()}
                </Columns>
                <PrintCustomerCollectionSheet vehicle={vehicle} finance={financeAgreement} service={service}/>
            </div>
        )
    }

}

export default PrintSalesInvoice